import { ProcessErrors } from '../config/processErrors.ts';

export const getProcessErrorType = (errors: any): ProcessErrors => {
	return errors.some((error) => error.type === ProcessErrors.ADF_CONVERSION_ERROR)
		? ProcessErrors.ADF_CONVERSION_ERROR
		: ProcessErrors.PROCESS_IMAGE_ERROR;
};
